import packageJson from '../package.json';

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  auth: {
    method: 'supabase';
    skip: boolean;
    redirectPath: string;
  };
  chat: { wsUrl: string };
  supabase: { url: string; key: string };
  posthog: { key: string; host: string };
  marketingAnalytics: { apiUrl: string; functionUrl: string; adminToken: string };
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: 'Lint',
  appVersion: packageJson.version,
  serverUrl: import.meta.env.VITE_PUBLIC_SERVER_URL ?? '',
  /**
   * Auth.
   * @method supabase
   */
  auth: {
    method: 'supabase',
    skip: false,
    redirectPath: '/',
  },
  /**
   * Supabase
   */
  supabase: {
    url: import.meta.env.VITE_PUBLIC_SUPABASE_URL ?? '',
    key: import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY ?? '',
  },
  chat: {
    wsUrl: import.meta.env.VITE_PUBLIC_CHAT_WS_URL ?? '',
  },
  /**
   * PostHog Analytics
   */
  posthog: {
    key: import.meta.env.VITE_PUBLIC_POSTHOG_KEY ?? '',
    host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST ?? 'https://app.posthog.com',
  },
  marketingAnalytics: {
    apiUrl: import.meta.env.VITE_MARKETING_ANALYTICS_API_URL ?? '',
    functionUrl: import.meta.env.VITE_MARKETING_ANALYTICS_FUNCTION_URL ?? '',
    adminToken: import.meta.env.VITE_IMARKETER_ADMIN_TOKEN ?? '',
  },
};
